const routePrefix = {
    auth: 'auth',
    users: 'users',
    debates: 'debates',
    tags: 'tags',
    feedbacks: 'feedbacks',
    comments: 'comments'
}

export default {
    routes: {
        home: {
            path: '/',
            slug: 'home',
            name: 'home',
            autoload: false,
        },
        search: {
            path: '/search',
            slug: 'search',
            name: 'search',
            autoload: false,
        },
        username: {
            path: '/:username',
            slug: 'profile/:username',
            name: 'username',
            autoload: false,
        },
        debate: {
            path: '/debate/:slug',
            slug: routePrefix.debates,
            name: 'debate',
            singleType: 'singleDebate',
            autoload: false,
        },
        register: {
            path: '/register',
            slug: 'get-tags-for-user',
            name: 'register',
            autoload: false
        },
        profileEdit: {
            path: '/profile/edit',
            slug: `${routePrefix.users}/profile-data`,
            name: 'profileEdit',
            autoload: false,
            private: true
        },
        debateCreate: {
            path: '/profile/debate/create',
            slug: `${routePrefix.debates}/form-data`,
            name: 'debateCreate',
            autoload: false,
            private: true
        },
        debateEdit: {
            path: '/profile/debate/edit',
            slug: `profile`,
            name: 'debateEdit',
            autoload: false,
            private: true
        },
        notifications: {
            path: '/notifications',
            slug: `notifications`,
            name: 'notifications',
            autoload: false,
            private: true
        },
        aboutUs: {
            path: '/about-us',
            slug: 'about-us',
            name: 'aboutUs',
            autoload: false
        },
        contactUs: {
            path: '/contact-us',
            slug: 'contact-us',
            name: 'contactUs',
            autoload: false
        },
        faq: {
            path: '/faq',
            slug: 'faq',
            name: 'faq',
            autoload: false
        },
        privacyPolicy: {
            path: '/privacy-policy',
            slug: 'privacy-policy',
            name: 'privacyPolicy',
            autoload: false
        },
    },
    routePrefix: routePrefix,
    colors: [
        '#823FF0',
        '#F03F54',
        '#8DD432',
        '#FF8525',
    ]
}